import React from 'react';

import { StraightArrowUpRightIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

import st from './StatisticsCard.module.sass';

export function StatisticsCard({
  title, image, onClick, testid,
}) {
  return (
    <div
      className={st.StatisticsCard}
      data-testid={`card.${testid}`}
    >
      <div className={st.Title}>
        <h5>{title}</h5>
        <Control.IconButton
          data-testid={`button.${testid}`}
          icon={<StraightArrowUpRightIcon />}
          kind="secondary"
          onClick={onClick}
        />
      </div>
      <div>
        <img
          alt={title}
          className={st.Image}
          src={image}
        />
      </div>
    </div>
  );
}
